import useSetMessageHandler from "../hooks/useSetMessageHandler";
import useBankformData from "./useBankformData";
import BillingAddressForm from "../billing-address/BillingAddressForm";
import { TextInput2, Selectinput } from "../../components/Inputs";

export default function BankForm() {
    const bankformData = useBankformData()
    useSetMessageHandler(bankformData.submit, bankformData.clearForm)

    if (!bankformData.accountId) {
        return (
            <div>accountId is not given</div>
        )
    }

    const accountTypeOptions = [
        { label: "Select an account type", value: '' },
        { label: "Personal Checking", value: 'personal_checking' },
        { label: "Personal Savings", value: 'personal_savings' },
        { label: "Business Checking", value: 'business_checking' },
        { label: "Business Savings", value: 'business_savings' },
    ];

    return (
        <div className="p-1">
            <div className="mb-4">
                <TextInput2
                    label="Name on account"
                    placeholder="Full name on the account"
                    value={bankformData.name}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => bankformData.setName(e.target.value)}
                />
            </div>
            <div className="mb-4">
                <TextInput2
                    label="Account Number"
                    placeholder="Account Number"
                    value={bankformData.accountNumber}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => bankformData.setAccountNumber(e.target.value)}
                />
            </div>
            <div className="mb-4">
                <TextInput2
                    label="Routing Number"
                    placeholder="Routing Number"
                    value={bankformData.routingNumber}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => bankformData.setRoutingNumber(e.target.value)}
                />
            </div>
            <div className="mb-4">
                <Selectinput
                    label="Account Type"
                    name="accountType"
                    value={bankformData.accountType}
                    options={accountTypeOptions}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => bankformData.setAccountType(e.target.value)}
                />
            </div>
            {bankformData.billingAddress &&
                <BillingAddressForm
                    addressLine1={bankformData.addressLine1}
                    setAddressLine1={bankformData.setAddressLine1}
                    addressLine2={bankformData.addressLine2}
                    setAddressLine2={bankformData.setAddressLine2}
                    city={bankformData.city}
                    setCity={bankformData.setCity}
                    state={bankformData.state}
                    setState={bankformData.setState}
                    zipcode={bankformData.zipcode}
                    setZipcode={bankformData.setZipcode}
                    country={bankformData.country}
                    setCountry={bankformData.setCountry}
                />
            }
            {/* <button onClick={bankformData.submit}>test</button> */}
            {/* {`http://localhost:3000/bank-form?accountId=acc-c068c34e-b12d-48b1-bc5f-c85edae9fc9b&ownerType=merchant`} */}
        </div>
    )
}